"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSuccessCbhResponse = exports.toErrorCbhResponse = void 0;
const cbh_error_1 = require("./cbh-error");
function toErrorCbhResponse(issues) {
    return { success: false, error: new cbh_error_1.CbhError(issues) };
}
exports.toErrorCbhResponse = toErrorCbhResponse;
function toSuccessCbhResponse(data) {
    return { success: true, data };
}
exports.toSuccessCbhResponse = toSuccessCbhResponse;
//# sourceMappingURL=cbh-response.js.map